import { CountryOption } from "@/domain/entities/BookingV4";

export const countries: CountryOption[] = [
  new CountryOption({
    flag: "indonesia",
    code: "+62",
    name: "Indonesia",
    countryCode: "ID",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "saudi_arabia",
    code: "+966",
    name: "Saudi Arabia",
    countryCode: "SA",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "uni_emirate_arab",
    code: "+971",
    name: "Uni Emirat Arab",
    countryCode: "AE",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "australia",
    code: "+61",
    name: "Australia",
    countryCode: "AU",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "jepang",
    code: "+81",
    name: "Jepang",
    countryCode: "JP",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "korea",
    code: "+82",
    name: "Korea Selatan",
    countryCode: "KR",
    nationalPrefix: "82"
  }),
  new CountryOption({
    flag: "brunei",
    code: "+673",
    name: "Brunei",
    countryCode: "BN",
    nationalPrefix: ""
  }),
  new CountryOption({
    flag: "taiwan",
    code: "+886",
    name: "Taiwan",
    countryCode: "TW",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "philippines",
    code: "+63",
    name: "Filiphina",
    countryCode: "PH",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "hongkong",
    code: "+852",
    name: "Hongkong",
    countryCode: "HK",
    nationalPrefix: ""
  }),
  new CountryOption({
    flag: "vietnam",
    code: "+84",
    name: "Vietnam",
    countryCode: "VN",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "thailand",
    code: "+66",
    name: "Thailand",
    countryCode: "TH",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "singapore",
    code: "+65",
    name: "Singapore",
    countryCode: "SG",
    nationalPrefix: ""
  }),
  new CountryOption({
    flag: "malaysia",
    code: "+60",
    name: "Malaysia",
    countryCode: "MY",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "usa",
    code: "+1",
    name: "USA",
    countryCode: "US",
    nationalPrefix: "1"
  }),
  new CountryOption({
    flag: "germany",
    code: "+49",
    name: "Jerman",
    countryCode: "DE",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "cambodia",
    code: "+855",
    name: "Cambodia",
    countryCode: "KH",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "macau",
    code: "+853",
    name: "Macau",
    countryCode: "MO",
    nationalPrefix: ""
  }),
  new CountryOption({
    flag: "netherland",
    code: "+31",
    name: "Netherland",
    countryCode: "NL",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "france",
    code: "+33",
    name: "Prancis",
    countryCode: "FR",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "uk",
    code: "+44",
    name: "Inggris",
    countryCode: "GB",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "turkey",
    code: "+90",
    name: "Turki",
    countryCode: "TR",
    nationalPrefix: "9"
  }),
  new CountryOption({
    flag: "qatar",
    code: "+974",
    name: "Qatar",
    countryCode: "QA",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "canada",
    code: "+1",
    name: "Kanada",
    countryCode: "CA",
    nationalPrefix: "1"
  }),
  new CountryOption({
    flag: "newzeland",
    code: "+64",
    name: "New Zealand",
    countryCode: "NZ",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "india",
    code: "+91",
    name: "India",
    countryCode: "IN",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "timor-leste",
    code: "+670",
    name: "Timor Leste",
    countryCode: "TL",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "china",
    code: "+86",
    name: "China",
    countryCode: "CN",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "italy",
    code: "+39",
    name: "Italy",
    countryCode: "IT",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "south_africa",
    code: "+27",
    name: "South Africa",
    countryCode: "ZA",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "bangladesh",
    code: "+880",
    name: "Bangladesh",
    countryCode: "BD",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "oman",
    code: "+968",
    name: "Oman",
    countryCode: "OM",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "kuwait",
    code: "+965",
    name: "Kuwait",
    countryCode: "KW",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "spain",
    code: "+34",
    name: "Spain",
    countryCode: "ES",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "pakistan",
    code: "+92",
    name: "Pakistan",
    countryCode: "PK",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "sri_lanka",
    code: "+94",
    name: "Sri Lanka",
    countryCode: "LK",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "morocco",
    code: "+212",
    name: "Morocco",
    countryCode: "MA",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "egypt",
    code: "+20",
    name: "Egypt",
    countryCode: "EG",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "austria",
    code: "+43",
    name: "Austria",
    countryCode: "AT",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "belgium",
    code: "+32",
    name: "Belgium",
    countryCode: "BE",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "greece",
    code: "+30",
    name: "Greece",
    countryCode: "GR",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "sweden",
    code: "+46",
    name: "Sweden",
    countryCode: "SE",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "kazakhstan",
    code: "+7",
    name: "Kazakhstan",
    countryCode: "KZ",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "findland",
    code: "+365",
    name: "Findland",
    countryCode: "FI",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "monaco",
    code: "+377",
    name: "Monaco",
    countryCode: "MC",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "denmark",
    code: "+45",
    name: "Denmark",
    countryCode: "DK",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "mexico",
    code: "+52",
    name: "Mexico",
    countryCode: "MX",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "brazil",
    code: "+55",
    name: "Brazil",
    countryCode: "BR",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "costa_rica",
    code: "+506",
    name: "Costa Rica",
    countryCode: "CR",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "venezuela",
    code: "+58",
    name: "Venezuela",
    countryCode: "VE",
    nationalPrefix: "0"
  }),
  new CountryOption({
    flag: "peru",
    code: "+51",
    name: "Peru",
    countryCode: "PE",
    nationalPrefix: "0"
  })
];
